export default {
    bindings: {
        'coreId': '@',
        'customerName': '@',
    },
    controller: 'accountPasswordController',
    template: require('../views/app.setPassword.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/components/app.setPassword.component.js